import CircularProgress from '../CircularProgress';

export default function Loading() {
  return (
    <div className="fixed-tail z-50 inset-0 flex items-center bg-black bg-opacity-50 justify-center overflow-auto h-[100vh] left-40 top-4">
      <CircularProgress component="padrao" className="text-neutras-white h-7 w-7" />
    </div>
  );
}
